// API Service für Backend-Kommunikation - immer HTTPS verwenden
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://backend.mtsdemo.de';

// Debug-Logging für API-URLs
console.log('API Service Base URL:', API_BASE_URL);

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  // Helper method to get auth headers
  getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : '',
    };
  }

  // Generic request method
  async request(url, options = {}) {
    // Stelle sicher, dass die URL immer HTTPS verwendet
    if (url.startsWith('http://')) {
      url = url.replace('http://', 'https://');
    }
    
    console.log('API Request URL:', url); // Debug-Logging
    
    const config = {
      headers: this.getAuthHeaders(),
      ...options,
    };

    try {
      const response = await fetch(url, config);
      
      if (!response.ok) {
        // Bei 401/403 Fehlern Token löschen und zur Login-Seite weiterleiten
        if (response.status === 401 || response.status === 403) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          throw new Error('Not authenticated');
        }
        
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || `HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Users API
  async getUsers() {
    return this.request(`${this.baseURL}/api/users/`);
  }

  async approveUser(userId) {
    return this.request(`${this.baseURL}/api/users/${userId}/approve`, {
      method: 'PUT',
    });
  }

  async rejectUser(userId) {
    return this.request(`${this.baseURL}/api/users/${userId}/reject`, {
      method: 'PUT',
    });
  }

  async toggleUserStatus(userId) {
    return this.request(`${this.baseURL}/api/users/${userId}/toggle-status`, {
      method: 'PUT',
    });
  }

  async deleteUser(userId) {
    return this.request(`${this.baseURL}/api/users/${userId}`, {
      method: 'DELETE',
    });
  }

  // Auth API
  async getCurrentUser() {
    return this.request(`${this.baseURL}/api/auth/me`);
  }

  async login(email, password) {
    return this.request(`${this.baseURL}/api/auth/login`, {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  }

  async register(userData) {
    return this.request(`${this.baseURL}/api/auth/register`, {
      method: 'POST',
      body: JSON.stringify(userData),
    });
  }
}

// Export singleton instance
export default new ApiService();
